import styled from "styled-components";
import { getTheme } from "Theme";
const theme = getTheme();

// New global standard for creating forms in app. examble of use is the Contact Us form in contact.jsx

export const Container = styled.div`
  width: 480px;
  margin: auto;
  margin-top: 10rem;
  padding: 2.5rem 2rem;
  border: none;
  border-radius: 16px;
  box-shadow:
    0 4px 24px rgba(0, 0, 0, 0.08),
    0 1.5px 4px rgba(0, 0, 0, 0.04);
  background: #fff;
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 24px;
  color: #222;
  font-weight: 700;
`;

export const SubTitle = styled.h3`
  text-align: center;
  margin-bottom: 18px;
  color: #222;
  font-weight: 700;
`;

export const SuccessMessage = styled.div`
  text-align: center;
  color: #2e7d32;
  font-size: 18px;
`;

export const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: ${(props) => props.width || "100%"};
  margin: ${(props) => props.margin};
`;

const StyledLabel = styled.label`
  font-weight: 700;
  color: ${theme.MAIN_COLOR};
  font-size: 18px;
  letter-spacing: 0.5px;
  display: block;
  position: relative;
  cursor: ${(props) => (props.tooltip ? "help" : "default")};
`;

const Tooltip = styled.span`
  visibility: hidden;
  color: ${theme.MAIN_COLOR};
  background-color: ${theme.PAGE_BACKGROUND};
  text-transform: none;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: normal;
  padding: 8px 12px;
  border-radius: 6px;
  position: absolute;
  z-index: 1000;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  width: 80%;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 10%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: ${theme.PAGE_BACKGROUND} transparent transparent transparent;
  }

  ${StyledLabel}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

export const Label = ({ children, tooltip }) => {
  return (
    <StyledLabel>
      {children} {tooltip && <i className="fa fa-question-circle" />}
      {tooltip && <Tooltip>{tooltip}</Tooltip>}
    </StyledLabel>
  );
};

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
  transition: border 0.2s;
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  margin-top: 6px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
  resize: vertical;
  transition: border 0.2s;
  min-height: 120px;
`;

export const SubmitButton = styled.div`
  margin-top: 8px;
  padding: 14px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 8px;
  background: linear-gradient(90deg, #00c6ff 0%, #0072ff 100%);
  color: #fff;
  border: none;
  box-shadow: 0 4px 16px rgba(0, 114, 255, 0.1);
  cursor: pointer;
  transition:
    background 0.2s,
    transform 0.1s;
  letter-spacing: 1px;
  text-transform: uppercase;
  outline: none;
  text-align: center;
  &:active {
    transform: scale(0.97);
  }
  &:disabled {
    background: #bdbdbd;
    color: #fff;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.7;
  }
`;

export const ButtonContent = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 900;
  letter-spacing: 4px;
`;

export const Checkbox = ({ label, onCheck, value }) => {
  return (
    <div
      style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
      onClick={onCheck}
    >
      <input
        type="checkbox"
        checked={value}
        style={{
          accentColor: "#1565c0",
          width: "18px",
          height: "18px",
          marginRight: "8px",
          cursor: "pointer",
          verticalAlign: "middle",
        }}
      />
      <div style={{ display: "inline-block", verticalAlign: "middle" }}>
        {label}
      </div>
    </div>
  );
};
